import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ContextMenu } from "../../../../library-templates/context--menu/ContextMenu";
import { ContextMenuCreator } from "../../../../library-templates/context--menu/ContextMenuCreator";
import { HeaderMenu } from "../HeaderMenu";
import { LinkContextEntry } from "../LinkContextMenuEntry";


export class Labs_en extends ContextMenuCreator
{
  static value = new AttributeValue( ContextMenuCreator.attribute, "labs-en" );
  
  get value(){ return Labs_en.value }
  
  create( e:Element ):ContextMenu
  {
    let entries:LinkContextEntry[] =
    [
      { label:"Overview", link:"::/en/labs/overview" },

      { label:"AI", link:"::/en/labs/ai/overview" },
      { label:"Assets", link:"::/en/labs/assets/overview" },
      { label:"Blender", link:"::/en/labs/blender/overview" },
      { label:"CMD", link:"::/en/labs/cmd/overview" },
      { label:"Fonts", link:"::/en/labs/fonts/overview" },      
      { label:"Game Dev", link:"::/en/labs/game-dev/overview" },
      { label:"Git", link:"::/en/labs/git/overview" },  
      { label:"Gitea", link:"::/en/labs/gitea/overview" },      
      { label:"Godot", link:"::/en/labs/godot/overview" },  
      
      { label:"Linux", link:"::/en/labs/linux/overview" }, 
      { label:"Photogrammetry", link:"::/en/labs/photogrammetry/overview" },
      { label:"Rokojori___ Action Library", link:"::/en/labs/rokojori-action-library/overview" },

      { label:"SSH", link:"::/en/labs/ssh/overview" },    
      { label:"Steamworks", link:"::/en/labs/steamworks/overview" }

    ];

    return HeaderMenu.create( "Labs", entries );
  }
}